//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import wx from "weixin-js-sdk";
// var wx = require('weixin-js-sdk')
// import wx from "weixin-jsapi"
const wx = window.jWeixin || require("weixin-js-sdk");
// import wx from '../wxjs'
var geolocation = new qq.maps.Geolocation(
  "T7SBZ-OJTL3-2PU3S-YHABH-GYHJK-FVFXQ",
  "HFB-hui-yuan-duan"
);
export default {
  name: "youhuiquan",
  data() {
    return {
      yhq_type: true,
      is_show: 0,
      ziji_num: 0,
      zengsong_num: 0,
      yhqList: [],
      coupons_id: "",
      yhqxqList: {},
      token: "",
      setTimeoutObj: null
    };
  },
  methods: {
    ziji() {
      this.yhq_type = true;
      this.is_show = 1;
      this.$HTTP
        .HttpPost("/member/coupon/getCouponsList", { token: this.token })
        .then(data => {
          this.yhqList = data.data.data;
          for (let i in this.yhqList) {
            this.yhqList[i].youxiaoqi =
              new Date(this.yhqList[i].begin_time * 1000).toLocaleDateString() +
              "至" +
              new Date(this.yhqList[i].end_time * 1000).toLocaleDateString();
          }
        });
    },
    zengsong() {
      this.yhq_type = false;
      this.is_show = 1;
      this.$HTTP
        .HttpPost("/member/coupon/getShareCouponsList", { token: this.token })
        .then(data => {
          this.yhqList = data.data.data;
          for (let i in this.yhqList) {
            this.yhqList[i].youxiaoqi =
              new Date(this.yhqList[i].begin_time * 1000).toLocaleDateString() +
              "至" +
              new Date(this.yhqList[i].end_time * 1000).toLocaleDateString();
          }
        });
    },
    shiyong(id) {
      this.is_show = 2;
      this.$HTTP
        .HttpPost("/member/coupon/getCouponDetail", {
          id: id,
          token: this.token
        })
        .then(data => {
          this.yhqxqList = data.data.data;
          this.yhqxqList.content = this.yhqxqList.content.replace(
            /<img/g,
            "<img style='width:100%;'"
          );
          this.coupons_id = data.data.data.coupons_id;
          let id = this.yhqxqList.id;
          let hid = this.yhqxqList.hid;

          this.yhqxqList.start_time = new Date(
            this.yhqxqList.start_time * 1000
          ).toLocaleDateString();
          this.yhqxqList.end_time = new Date(
            this.yhqxqList.end_time * 1000
          ).toLocaleDateString();
          if (this.yhqxqList.get_status == 0) {
            this.wxfengxiang(id, hid);
            this.dingshi();
          }
          if (!this.yhq_type) {
            this.wxfengxiang(id, hid);
          }
        });
    },
    wxfengxiang(id, hid) {
      console.log("分享");
      wx.ready(() => {
        wx.onMenuShareTimeline({
          title: this.yhqxqList.share_title,
          desc: this.yhqxqList.share_describe,
          link: `https://h5.hfbsoftware.com/#/youhuiquan/?id=${id}&hid=${hid}`,
          imgUrl: require("./../../static/img/business.png"),
          success: () => {
            //  this.$vux.alert.show({
            //     content: `https://h5.hfbsoftware.com/#/youhuiquan/?id=${id}&hid=${hid}`
            //   });
          }
        });
        wx.onMenuShareAppMessage({
          title: this.yhqxqList.share_title,
          desc: this.yhqxqList.share_describe,
          link: `https://h5.hfbsoftware.com/#/youhuiquan/?id=${id}&hid=${hid}`,
          imgUrl: require("./../../static/img/business.png"),
          success: () => {
            //  this.$vux.alert.show({
            //     content: `https://h5.hfbsoftware.com/#/youhuiquan/?id=${id}&hid=${hid}`
            //   });
          }
        });
      });
    },
    fenxiang(id) {
      this.$vux.alert.show({
        content: "点击右上方选择分享朋友"
      });
      // this.wxfengxiang(id)
    },
    bt_ljsy(id) {
      this.$HTTP
        .HttpPost("/member/coupon/getCoupon", { id: id, token: this.token })
        .then(data => {
          this.$vux.toast.show({
            text: data.data.msg,
            type: "text",
            width: "80%",
            isShowMask: true
          });
          if (data.data.code == 200) {
            this.yhqxqList.get_status = 1;
            this.setTimeoutObj = null;
            this.is_show = 0;
          }
        });
    },
    call(tel) {
      window.location.href = "tel://" + tel;
    },
    dingshi() {
      this.setTimeoutObj = setTimeout(() => {
        if (this.is_show === 2) {
          this.dingshi();
          this.$HTTP.HttpPost("/member/coupon/clickTime", {
            coupons_id: this.coupons_id,
            token: this.token
          });
        } else {
          return;
        }
      }, 7000);
    },
    getUrlCode(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
    getMsg() {
      this.$HTTP
        .HttpPost("/member/wechat/getSignInfo", {
          token: this.token,
          url: window.location.protocol + "//" + window.location.host + "/"
        })
        .then(data => {
          wx.config({
            debug: false,
            appId: data.data.data.appid,
            timestamp: data.data.data.timestamp,
            nonceStr: data.data.data.noncestr,
            signature: data.data.data.signature,
            jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"]
          });
        });
      this.$HTTP
        .HttpPost("/member/coupon/getMyActivity", { token: this.token })
        .then(data => {
          this.ziji_num = data.data.data.myself;
          this.zengsong_num = data.data.data.share;
        });
    }
  },
  created() {
    if (sessionStorage.getItem("show") === "show") {
      this.is_show = 2;
    }
    let id = this.getUrlCode("id");
    console.log(id);
    let hid = this.$router.currentRoute.query.hid;
    sessionStorage.setItem("hid", hid);
    // this.token = this.$router.currentRoute.query.token;
    // sessionStorage.setItem("token", this.token);
    this.token = sessionStorage.getItem("token");
    if (!this.token) {
      this.is_show = 2;
      if (this.getUrlCode("code") && !sessionStorage.getItem("token")) {
        sessionStorage.setItem("isShow", "show");
        const code = this.getUrlCode("code");
        this.$api.login(code).then(() => {
          this.getMsg();
          this.shiyong(id);
        });
      }
      if (!sessionStorage.getItem("token") && !this.getUrlCode("code")) {
        this.$api.getAppid(window.location.href);
      }
    } else {
      this.getMsg();
    }
  },
  mounted() {}
};



// WEBPACK FOOTER //
// ./src/components/youhuiquan.vue